import React, {Component} from 'react';
import {Loading, Carousel} from "common-import/custom";
import {inject, observer} from "mobx-react";
import {VarHelper} from "common-import/helpers";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

@inject("slideShopStore", "userStore", "productStore") @observer
export default class SlideShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slides: [],
      current: [],
      isLoading: true,
      keyword: "",
      listProduct: [],
      isSearching: false,
    }
  };

  async componentDidMount() {
    const { userStore, slideShopStore } = this.props;
    await userStore.onReady();
    const res = await slideShopStore.getList();
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({isLoading: false, slides: res.data.slice(), current: res.data.slice()});
  };

  handleAdd = async (e, index) => {
    !!e && e.preventDefault();
    const { listProduct, current } = this.state;
    const { slideShopStore } = this.props;
    listProduct[index].isAdding = true;
    this.setState({listProduct});
    const item = listProduct.find((itm, idx) => index === idx);
    const listImages = !!item.images ? item.images.slice() : [];
    const payload = {
      productName: item.name,
      productId: item.id,
      slideMobiles: listImages,
      slidePcs: listImages,
    };
    const res = await slideShopStore.create(payload);
    listProduct[index].isAdding = false;
    this.setState({listProduct});
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({current: [res.data, ...current]});
    window.toast.info("Added successfully!");
  };

  handleRemove = async (e, index) => {
    !!e && e.preventDefault();
    let { current } = this.state;
    const { slideShopStore } = this.props;
    const item = current.find((itm, idx) => index === idx);
    if (!window.confirm("Are you sure want to DELETE " + item.productName)) return null;
    current[index].isDeleting = true;
    this.setState({current});
    const res = await slideShopStore.delete({id: item.id});
    current[index].isDeleting = false;
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    current = current.filter((itm, idx) => idx !== index);
    this.setState({current});
    return window.toast.info("DELETED successfully!");
  };

  renderListAdded = () => {
    const { current } = this.state;
    return (
      <div>
        <div className="card">
          <div className="card-body">
            {
              current.slice().map((item, index) => {
                return (
                  <div className="row mb-16" key={item.id+index}>
                    <div className="col-md-3">
                      <img style={{width:'70px'}} src={VarHelper.img(item.slidePcs[0]) || defaultImage} alt=""/>
                    </div>
                    <div className="col-md-6">
                      {item.productName}
                    </div>
                    <div className="col-md-3">
                      <button className="btn btn-sm btn-danger" disabled={item.isDeleting} onClick={e => this.handleRemove(e, index)}>
                        <i className="fa fa-trash"> </i>  {item.isDeleting ? 'Deleting...':'Delete'}
                      </button>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  };

  renderListProduct = () => {
    const { listProduct } = this.state;

    if (!listProduct) return null;

    return (
      <div className="list-product" style={{marginBottom: '40px'}}>
        {
          listProduct.slice().map((item, index) => {
            return (
              <div className="row mb-16" key={item.name+index}>
                <div className="col-md-3">
                  <img src={VarHelper.img(item.images[0]) || defaultImage} alt="" className="img-responsive" style={{width: '50px'}}/>
                </div>
                <div className="col-md-6">
                  <p>{item.name}</p>
                </div>
                <div className="col-md-3">
                  <button className="btn btn-sm btn-primary" onClick={e => this.handleAdd(e, index)} disabled={item.isAdding}>
                    <i className="fa fa-dot-circle-o"> </i> {item.isAdding ? 'Adding...':'Add to slide'}
                  </button>
                </div>
              </div>
            )
          })
        }
      </div>
    );
  };

  render() {
    const { current, isLoading, isSearching } = this.state;

    if (isLoading) return (<Loading> </Loading>);

    let listImages = [];
    for (let i = 0; i < current.length; i++) {
      const item = {
        src: VarHelper.img(current[i].slidePcs[0]) || defaultImage,
        altText: '',
        caption: '',
      };
      listImages = [...listImages, item];
    }

    return (
      <div className="animated fadeIn" id="slide-shop-page">
        <div className="card">
          <div className="card-header">
            Slide shop
          </div>
          <div className="card-body">
            <div className="form" style={{marginBottom: '24px'}}>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <button className="btn btn-primary" onClick={e => this.search(e)} disabled={isSearching}>
                      <i className="fa fa-search"> </i> {isSearching ? 'Searching...':'Search'}
                    </button>
                  </div>
                  <input disabled={isSearching} type="text" className="form-control" onChange={e => this.setState({keyword: e.target.value})}
                         onKeyPress={async (e) => {
                           if (e.key === 'Enter') {
                             await this.search();
                           }
                         }}
                  />
                </div>
              </div>
            </div>
            {this.renderListProduct()}
            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <Carousel items={listImages}> </Carousel>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                {this.renderListAdded()}
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
              <i className="fa fa-long-arrow-left"> </i> Go back
            </button>
          </div>
        </div>
      </div>
    );
  }

  search = async e => {
    !!e && e.preventDefault();
    const { productStore } = this.props;
    const { keyword } = this.state;
    if (keyword.trim() === "") return null;
    this.setState({isSearching: true});
    await productStore.getListApproved();
    this.setState({
      isSearching: false,
      listProduct: productStore.listApproved
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Other/SlideShop.js